import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  containerForm: {
    marginTop: theme.spacing(2),
  },
  botoesFormulario: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2.5),
    width: '100%',
    alignItems: 'center',
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  formGroup: {
    padding: theme.spacing(2),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  grupoEspelho: {
    padding: theme.spacing(2),
  },
  captionText: {
    display: 'block',
    marginTop: theme.spacing(0.5),
  },
  embalagemTitulo: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
  },
}))

export default useStyles
